module.exports = __webpack_public_path__ + "static/media/stars-less-3840.85dcad10.jpg";